// extracted by mini-css-extract-plugin
export default {"image":"Song_image__cj4Jo"};